import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#select_item
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSelectItemItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackSelectItemParameters
    extends TrackEventListParameters<"item_list_id" | "item_list_name", null, TrackSelectItemItem> {}

const trackSelectItem = (parameters: TrackSelectItemParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "select_item", ...parameters }, { ...options, skipItemIndex: true });
};

export default trackSelectItem;
